import { Dialog } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
const ConfirmRejectedDialog = (props: any) => {
  const { agreeFun, setIsRejected } = props;
  const handleAgree = () => {
    agreeFun();
    setIsRejected(false);
  };
  const handleDisAgree = () => {
    setIsRejected(false);
  };
  return (
    <div>
      <Dialog className="pw-rejected-dialog-container" open={true}>
        <div className="pw-dialog-container">
          <div className="flex justify-between items-center w-full">
            <div className={`pw-header-text`}>
              Update to <span className={`pw-Rejected-option`}>Rejected</span>
            </div>
            <div className="cursor-pointer">
              <CloseIcon
                className="pw-color-close-attchments"
                onClick={() => setIsRejected(false)}
              />
            </div>
          </div>
          <div className="flex justify-between items-center w-full mt-8">
            <div className="text-sm">
              Please note that it can't be updated further after updating the
              status to rejected
            </div>
          </div>
        </div>
        <div className="flex flex-row mt-16 justify-end pw-bunit-footer w-full gap-6">
          <div
            onClick={handleDisAgree}
            className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold"
          >
            Cancel
          </div>
          <div
            onClick={handleAgree}
            className={`pw-bunit-button-primary "pw-bg-error" pw-bunit-button-save text-white
             ${"cursor-pointer bg-primary"}`}
          >
            Update
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default ConfirmRejectedDialog;
